var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCvoDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#fff",
    stroke: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1ca6ff",
    stroke: "#1ca6ff",
    strokeWidth: "0.8px",
    d: "M21.635 10.791a7.685 7.685 0 0 0-7.512 6.4 6.686 6.686 0 0 0 .584 13.336H29.9v-1.211l-15.19-.2a5.287 5.287 0 0 1 0-10.572.7.7 0 0 0 .69-.644 6.3 6.3 0 0 1 6.234-5.7 5.827 5.827 0 0 1 4.351 1.894.684.684 0 0 0 .747.165 5.5 5.5 0 0 1 1.829-.3 4.889 4.889 0 0 1 4.849 4.306.7.7 0 0 0 .455.584 5.32 5.32 0 0 1-1.84 10.263l-2.128.2v1.208h2.128a6.7 6.7 0 0 0 2.7-12.785 6.289 6.289 0 0 0-6.159-5.187 6.89 6.89 0 0 0-1.9.286 7.224 7.224 0 0 0-5.031-2.043z",
    transform: "translate(9.078 10.872)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvoDefault);
export default __webpack_public_path__ + "static/media/cvo-default.b5903dc01b5fc91c352f1017cf02c6b2.svg";
export { ForwardRef as ReactComponent };